module.exports = __webpack_public_path__ + "logo.0b648879.jpg";